import { ValueOf } from 'ts-essentials';
import { ListingResponse } from '~/modules/services/listing_service';
import { FeatureFlagsRecord } from '~/modules/stores/feature_flags_store';
import { WordPressState } from '~/modules/stores/wordpress_store';
import { deepFreeze } from '~/modules/utilities/object_utils';
import { ServerListingStoreState } from '~/modules/utilities/server_listing_store_shared';

const _API_VERSIONS = ['1', '2'] as const;
const _SCHEMA_VERSIONS = ['v1'] as const;

export type ApiVersion = (typeof _API_VERSIONS)[number];
export type SchemaVersion = (typeof _SCHEMA_VERSIONS)[number];

export const API_VERSIONS = _API_VERSIONS as unknown as string[];
export const SCHEMA_VERSIONS = _SCHEMA_VERSIONS as unknown as SchemaVersion[];

export const SCHEMA_VERSION: SchemaVersion = 'v1';
export const NEXT_SCHEMA_VERSION: SchemaVersion = 'v1';
export const SCHEMA_VERSION_QUERY_PARAM = 'schemaVersion'; // for API v1 backwards compatibility
export const SCHEMA_VERSION_HEADER = 'SchemaVersion';

export interface MoreFromThisProvider {
    id: string;
    listingUrl: string;
    averageRating: string;
    reviewsAmount: string;
    publisher: string;
    listingCategories: [];
    imageURL: string;
    title: string;
    description: string;
}

export interface CategoryData {
    id: number;
    name: string;
    url: string;
    order: number;
}

export interface CachedListing {
    id: string;
    external_id: string;
    type: string;
    title: string;
    description: string;
    listingCategories: { name: string; filter: string }[];
    logos: { logoType: string; mediaId: string }[];
    publisher: string;
    averageRating: number;
    reviewsAmount: number;
    chatEnabled: boolean;
    listing?: ListingResponse;
    sponsoredCampaigns: AnyObject[];
}

export interface InjectedStores {
    FEATURE_FLAGS: FeatureFlagsRecord;
    LISTING?: ServerListingStoreState;
    WORDPRESS?: WordPressState;
    HOME_CONTENT?: {
        feed: {
            category: Array<CategoryData>;
            sponsored: Array<CachedListing>;
            top_trending: Array<CachedListing>;
        };
        sections: Array<AnyObject>;
    };
}

//#region Try
export const TRY_TYPE_QUERY_PARAM = 'type';

export const TryOptionTypes = deepFreeze({
    None: 'None',
    Sandbox: 'Sandbox',
    TestDrive: 'TestDrive',
    Trialforce: 'Trialforce',
} as const);

export type TryOptionType = ValueOf<typeof TryOptionTypes>;
export type ValidTryOptionType = ValueOf<Omit<typeof TryOptionTypes, 'None'>>;
//#endregion Try
